jQuery(document).ready(function($) {
	$(".global-nav__item").on({
		mouseenter: function () {
			$(this).addClass('is-active');
			$(this).find('.global-nav__group').addClass('is-active');
		},
		mouseleave: function () {
			$(this).removeClass('is-active');
			$(this).find('.global-nav__group').removeClass('is-active');
		}
	});

	// Check data attribute instead of class
	if ($('.site-header').data('sticky') === true) {
		var $header = $('.site-header');
		var isSimple = $header.data('simpleSticky') === true;

		$(window).scroll(function(){
			if ($(window).scrollTop() >= 180) {
				$header.addClass('site-header--fixed');
				if (isSimple) {
					$header.addClass('site-header--simple');
				}
			} else {
				$header.removeClass('site-header--fixed site-header--simple');
			}
		});
	}
});
